<template>
  <p><!-- Template is refactored 100% --></p>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MessageList',
  props: {
    conversationp: {
      type: Object,
      default: () => {},
    },
    messageListHeight: {
      type: String,
      default: 'calc(100% - 104px)',
    },
  },
  data() {
    return {
      messages: [],
      page: 1,
      userId: localStorage.getItem('userId'),
      nextPageBefore: null,
      showScrollBottom: false,
      lastPage: false,
    };
  },
  computed: {
    ...mapGetters({
      members: 'merchant/members',
      sentMessageStatusFromPusher: 'pusher/sentMessageStatus',
      sentMessageStatus: 'chat/sentMessageStatus',
      newMessageConversation: 'pusher/newMessageConversation',
      newConversationActivity: 'pusher/newConversationActivity',
      messageList: 'chat/messageList',
      messagesLoaded: 'chat/messagesLoaded',
      conversationsLoad: 'chat/conversationsLoad',
      fileUploadError: 'chat/fileUploadError',
      chatFastReload: 'chat/chatFastReload',
    }),
    conversationsLoaded() {
      return this.conversationsLoad.loaded || (this.conversationsLoad.page !== 1);
    },
    latestMessage() {
      return this.$lodash.findLast(this.messages, message => message.direction !== 'activity');
    },
    conversationExists() {
      return !this.$lodash.isEmpty(this.conversationp);
    },
    conversationIsUnread() {
      return !this.conversationp.seen || (!this.conversationp.assignment_seen && (this.conversationp.user_id === this.userId));
    },
    loadingMessagesList() {
      return (!this.messagesLoaded && (this.page === 1) && this.conversationExists) || !this.conversationsLoaded;
    },
    noMoreMessages() {
      return this.messagesLoaded && this.lastPage && (this.page !== 1);
    },
  },
  watch: {
    messagesLoaded(conversation) {
      if (conversation && (conversation === this.conversationp.id)) {
        if (!this.$lodash.isEmpty(this.messageList.data)) {
          const messageToScroll = this.messageList.data[0].sid;
          if (this.page === 1) {
            this.saveFirstPageOfMessages({
              conversationId: conversation,
              messageList: this.$lodash.cloneDeep(this.messageList),
            });
            this.messages = this.$lodash.reverse(this.messageList.data);
            this.$nextTick(() => {
              this.$refs.messageScrollbar.scrollToBottom();
            });
          } else {
            this.messages = this.$lodash.concat(this.$lodash.reverse(this.messageList.data), this.messages);
            this.$nextTick(() => {
              this.$refs.messageScrollbar.scrollToElement(`#message-${messageToScroll}`, 145);
            });
          }
        } else {
          this.messages = [];
        }

        // Prevents accidental duplicate message received from BE
        this.messages = this.$lodash.uniqBy(this.messages, 'sid');

        this.nextMessagesBefore = this.messageList.meta.next_messages_before;
        this.lastPage = !this.nextMessagesBefore;
      }
    },
    newMessageConversation(messageData) {
      let messageExists = false;
      if (messageData.message.direction !== 'inbound') {
        messageExists = this.$lodash.find(this.messages, { sid: messageData.message.temp_sid });
        if (!messageExists) {
          messageExists = this.$lodash.find(this.messages, { sid: messageData.message.sid });
        }
      }

      // only add the message to the cache if the first page has been loaded to cache first
      if (this.chatFastReload[messageData.conversation.id]) {
        this.addMessageToFastLoad(messageData);
      }

      if ((this.conversationp.id === messageData.conversation.id) && !messageExists) {
        this.messages.push(messageData.message);
        this.$nextTick(() => {
          this.detectScrollAction();
        });
      }
    },
    newConversationActivity(payload) {
      if (this.conversationp.id === payload.conversation.id) {
        this.messages.push(payload.activity);
        this.$nextTick(() => {
          this.detectScrollAction();
        });
      }
    },
    sentMessageStatus(message) {
      this.changeMessageStatus(message);
    },
    sentMessageStatusFromPusher(message) {
      this.changeMessageStatus(message);
    },
    fileUploadError(errorData) {
      const sentMessageIndex = this.$lodash.findIndex(this.messages, msg => msg.sid === errorData.sid);
      if (errorData.error) {
        switch (errorData.error.status) {
          case 422: {
            this.messages[sentMessageIndex].error = errorData.error.data.errors.file[0];
            break;
          }
          case 413: {
            this.messages[sentMessageIndex].error = 'File is too big. Max size 16MB.';
            break;
          }
          default: {
            this.messages[sentMessageIndex].error = 'Something went wrong.';
            break;
          }
        }
        this.messages[sentMessageIndex].loading = false;
      }
    },
  },
  methods: {
    ...mapActions({
      fetchMessages: 'chat/fetchMessages',
      markConversationAsSeen: 'chat/markConversationAsSeen',
      listenForMessageStatus: 'pusher/listenForMessageStatus',
      saveFirstPageOfMessages: 'chat/saveFirstPageOfMessages',
      setMessages: 'chat/setMessages',
      addMessageToFastLoad: 'chat/addMessageToFastLoad',
    }),
    addTemplateMessage(message) {
      const messageExists = this.$lodash.find(this.messages, { sid: message.sid });
      if (messageExists) {
        return;
      }

      const latestMessage = {
        sid: message.sid,
        type: 'text',
        body: message.text,
        direction: 'template_message',
        status: 'sent',
        timestamp: this.$moment().format(),
      };

      this.addOutboundMessage(null, latestMessage);
    },
    addOutboundMessage(tempSid, message) {
      let latestMessage = {};

      if (!this.$lodash.isObject(message)) {
        latestMessage = {
          sid: tempSid,
          type: 'text',
          body: message,
          direction: 'outbound',
          status: 'sending',
          timestamp: this.$moment().format(),
        };
      } else {
        latestMessage = message;
      }

      this.conversationp.last_message = latestMessage.body;
      this.conversationp.message_direction = 'outbound';
      this.conversationp.message_sent_at = latestMessage.timestamp;
      this.$eventBus.$emit('newmessagesent', true);

      this.messages.push(latestMessage);
      this.$nextTick(() => {
        this.$refs.messageScrollbar.scrollToBottom();
      });
    },
    addOutboundMedia(fileData) {
      this.addOutboundMessage(fileData.temp_sid, {
        sid: fileData.temp_sid,
        type: 'file',
        body: fileData.media_name,
        media_type: fileData.media_type,
        media_url: '',
        loading: true,
        direction: 'outbound',
        status: 'sending',
        timestamp: this.$moment().format(),
      });
    },
    loadMessages() {
      // First check if the chat is available in the state for fast reload.
      if (this.page === 1 && this.chatFastReload[this.conversationp.id]) {
        this.setMessages(this.$lodash.cloneDeep(this.chatFastReload[this.conversationp.id]));
        this.messages = this.$lodash.reverse(this.messageList.data);
        this.nextMessagesBefore = this.messageList.meta.next_messages_before;
        this.lastPage = !this.nextMessagesBefore;
        this.$nextTick(() => {
          this.$refs.messageScrollbar.scrollToBottom();
        });
      } else {
        const payload = {
          merchant_id: this.$route.params.merchant_id,
          conversation_id: this.conversationp.id,
          filters: {
            page: this.page,
            messages_before: this.nextMessagesBefore,
          },
        };

        this.fetchMessages(payload);
      }
    },
    loadMoreMessages() {
      if (this.messagesLoaded && (!this.lastPage)) {
        this.page += 1;
        this.loadMessages();
      }
    },
    resetPagination() {
      this.page = 1;
      this.lastPage = false;
      this.nextMessagesBefore = null;
    },
    messagesSeen(seen) {
      if (!this.latestMessage || !this.conversationIsUnread) {
        return;
      }
      // setTimeout(() => {
      this.markConversationAsSeen({
        merchant_id: this.$route.params.merchant_id,
        conversation_id: this.conversationp.id,
        data: {
          seen,
        },
      });
      // }, 1000);
    },
    handleTopScroll() {
      if (!this.$lodash.isEmpty(this.conversationp)) {
        this.loadMoreMessages();
      }
    },
    handleBottomScroll() {
      this.showScrollBottom = false;
      if (this.conversationp.id) {
        this.messagesSeen(true);
      }
    },
    detectScrollAction() {
      const scrollPosition = this.$refs.messageScrollbar.getScrollBottomPosition();
      if (scrollPosition <= 2000) {
        this.moveToBottom(false);
      } else {
        this.showScrollBottom = true;
      }
    },
    // moveToBottom(animation = true) {
    //   this.showScrollBottom = false;
    //   this.$refs.messageScrollbar.scrollToBottom(animation);
    // },
    changeTempData(message) {
      const sentMessageIndex = this.$lodash.findIndex(this.messages, msg => msg.sid === message.temp_sid);
      this.messages[sentMessageIndex].sid = message.sid;
      if (message.type === 'file') {
        this.messages[sentMessageIndex].media_url = message.media_url;
        this.messages[sentMessageIndex].loading = false;
      }
    },
    changeMessageStatus(message) {
      if ((this.conversationp.id === message.conversation_id) &&
          (this.latestMessage && (this.latestMessage.sid === message.sid))) {
        this.latestMessage.status = message.status;
        this.conversationp.message_status = message.status;
      }
    },
    configureActivityMessage(activity) {
      const fromUser = this.$lodash.find(this.members, { id: activity.from_user_id });
      if (!fromUser) {
        return '';
      }
      const actionTime = this.$moment(activity.timestamp).fromNow();
      const toUser = activity.to_user_id ? this.$lodash.find(this.members, { id: activity.to_user_id }) : null;
      const fromUserName = fromUser.id === this.userId ? 'You' : fromUser.name;
      let toUserName = null;
      if (toUser) {
        if (toUser.id === this.userId) {
          toUserName = (fromUser.id === this.userId) ? 'yourself' : 'you';
        } else {
          toUserName = (fromUser.id === toUser.id) ? 'themself' : toUser.name;
        }
      }

      switch (activity.action) {
        case 'assignment': {
          const assignment = toUserName ? `assigned conversation to ${toUserName}` : 'unassigned conversation';
          return `${fromUserName} ${assignment} ${actionTime}.`;
        }
        case 'folder': {
          const oldFolder = activity.meta_data.old_folder.replace(/\b\w/g, l => l.toUpperCase());
          const newFolder = activity.meta_data.new_folder.replace(/\b\w/g, l => l.toUpperCase());
          return `${fromUserName} moved conversation from ${oldFolder} to ${newFolder} ${actionTime}.`;
        }
        case 'status_available':
          return `${fromUserName} changed conversation status to available ${actionTime}.`;
        case 'status_away':
          return `${fromUserName} changed conversation status to away ${actionTime}.`;
        default:
          return '';
      }
    },
    messageClass(direction) {
      return {
        'inbound-message': direction === 'inbound',
        'operator-message': direction === 'activity',
        'template-message': direction === 'template_message',
        'outbound-message': ['outbound', 'bot', 'template_message'].includes(direction),
      };
    },
    messageStatusIcon(status) {
      switch (true) {
        case (status === 'sending'): {
          return {
            class: 'sending',
            name: 'regular/circle',
          };
        }
        case (status === 'sent'): {
          return {
            class: 'sent',
            name: 'regular/check-circle',
          };
        }
        case (status === 'delivered') && (this.conversationp.message_status !== 'read'): {
          return {
            class: 'delivered',
            name: 'regular/check-circle',
          };
        }
        case (status === 'read') || (status === 'delivered' && this.conversationp.message_status === 'read'): {
          return {
            class: 'read',
            name: 'check-circle',
          };
        }
        case ['failed', 'undelivered'].includes(status): {
          return {
            class: 'failed',
            name: 'regular/times-circle',
          };
        }
        default: {
          return {
            class: 'sending',
            name: 'regular/circle',
          };
        }
      }
    },
  },
};
</script>
